import React from 'react'

import { useActionless, useAppSelector } from 'redux/hooks'
import { TOGGLE_MODAL } from 'redux/active/actions/types'

import { CardType } from 'types/deck'

import Modal from 'components/elements/Modal'
import BuyBulkModalBody from './buyBulkForm'

import styles from './buyBulkModal.module.scss'

type Props = {
  preSelectedCards?: CardType[]
  open?: boolean
  onClose?: () => void
  linkedFrom?: string
}

const BuyBulkModal = ({
  preSelectedCards,
  open: parentOpen,
  onClose: onParentClose,
  linkedFrom = 'bulkBuy',
}: Props) => {
  const reduxOpen = useAppSelector(state => state.active.modals.bulkBuy)

  const [toggleModal] = useActionless(TOGGLE_MODAL)

  return (
    <Modal
      open={parentOpen ?? reduxOpen}
      onClose={() => {
        if (onParentClose) return onParentClose()

        toggleModal({ modalName: 'bulkBuy', flag: false })
      }}
      closeButton
      modalClassName={styles.modal}>
      <BuyBulkModalBody open={parentOpen || reduxOpen} linkedFrom={linkedFrom} preSelectedCards={preSelectedCards} />
    </Modal>
  )
}

export default BuyBulkModal
